module.exports = __webpack_public_path__ + "assets/img/05.sync-1.d44ebb77.png";